import NewPanel from './adapter';

export default NewPanel;
